import { Box } from '@mui/material'
import React from 'react'

function Footer({options}) {
  return (
    <Box sx={{margin: '20px'}}>{options.footer}</Box>
  )
}

export default Footer